import i18n from "../../../utils/i18n.js";
import RegistrationContactPage from "../../searchFlowVersionB/components/registrationContactPage/RegistrationContactPage.jsx";

const RegContactPage = (props) => (
  <RegistrationContactPage
    recommendationTitle={i18n.t("searchflow.regofferrecommendation")}
    priceLabel={i18n.t("searchflow.regofferpricelabel")}
    priceAmount={i18n.t("searchflow.regofferpriceamount")}
    chipFields={["companytype", "industry", "activity", "foreigntrade"]}
    callbacksource="regrequest"
    createAspRequest={props.createAspRequest}
    onRequestError={props.onRequestError}
    handleNext={props.handleNext}
  />
);

export default RegContactPage;
